// import './vendor';
// import AOS from "aos";
// import Parallax from 'parallax-js' 

require ('./slider/slider-company.js');
require ('./slider/slider-services.js');
require ('./select.js');


// select
const selectBtn = document.querySelectorAll('.c-select__open');

for (let i = 0; i < selectBtn.length; i++) {
    selectBtn[i].addEventListener('click', (e) => {
        var dropdown = selectBtn[i].closest('.c-select');
        dropdown.classList.toggle('c-select-active');
        const select = dropdown.querySelectorAll('.c-select-row');
        e.preventDefault();
        
        for (let i = 0; i < select.length; i++) {
            select[i].classList.toggle('active');
        }
    });
}

// mob menu open
const openMenu = document.querySelector('.menu__item5');
const menuMob = document.querySelector('.l-header__bottom');

openMenu.addEventListener('click', (e) => {
    e.preventDefault();
    menuMob.classList.toggle('open');
    document.querySelector('.body').classList.toggle('overflow-hidden');
});

// submenu open
const menuItem = document.querySelectorAll('.c-menu__item');
const subMenu = document.querySelectorAll('.c-submenu');

for(let i = 0; i < subMenu.length; i++) {
    subMenu[i].parentElement.classList.add(`sub-arrow-${i}`);
}

const openSearch = document.querySelector('.c-search__btn');
const inputSearch = document.querySelector('.c-search__input');

openSearch.addEventListener('click', (e) => {
    e.preventDefault();
    inputSearch.classList.toggle('open');
});

// inputSearch.addEventListener('change', updateValue);

// function updateValue(e) {
//     let log = e.target.value;
//     const resultSearch = document.querySelector('.c-search__result');
//     if(log == 'Невролог') {
//         resultSearch.classList.remove('d-none');
//     } else {
//         resultSearch.classList.add('d-none');
//     }
// }
